import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  useGblz,
  a,
  ls,
  f,
  gs,
  BoxC,
  BtnC,
  GridC,
//  LineC,
  RootC,
  SrlC,
  TextC,
  _cv_31___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as RootC from "./_ccmRootC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hfDTM from './_hfDTM';

import * as icm from './icm';

import IccvFtr from './IccvFtr';

const $date = hfDTM.f(hfDTM.getTdy(), '年月日（曜）', false);

//let $_31rz = {} as ht.dz;

export const N = (pz: {
  sPz: ht.dz,
  cz?: {
    bHome?: ht.b,
    bLgt?: ht.b,
  },
  oClds: ht.ls,
}) => {

  //const _frcUdt = ls.frcUdt();

  const _gUserz = gs.useUserz();
  //const _i19ra1220i = _gUserz.crt.i19rz?.i19ra1220i;

  //hf.l(`icvBaseD10Rz 46: ${hf.s(_gUserz.crt.i18rz)}`)

  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        boxStlz: a(`sc/lt1`),
        oClds: [

          cr.c(SrlC.V, {
            key: -10,
            oClds: [

              cr.c(GridC.N, {
                key: -10,
                abtType: 'vclCmnz',
                lineCs: [
                  {
                    cellCs: [
                      {
                        oClds: [
                          cr.c(GridC.N, {
                            key: -10,
                            abtType: 'barHdrCmnz',
                            boxStlz: a(`sc/bl7`),
                            lineCs: [
                              {
                                boxStlz: a('dw/f sc/bl7'),
                                cellCs: [
                                  {
                                    boxStlz: a('f/1 fd/rsc ml/2'),
                                    oClds: [
                                      pz.cz?.bHome != false ?
                                      cr.c(BtnC.N, {
                                        key: -10,
                                        abtType: 'hdrHomeCmnz',
                                        bfrIconCz: {},
                                        lblCz: {},
                                        pslPtyz: {
                                          onPress: async () => {
                                            await pz.sPz.set({
                                              steps: [0,0]
                                            });
                                            cr.moveTo({
                                              pageName: 'icvHomeD10Rz',
                                            });
                                          }
                                        },
                                      })
                                      : undefined,
                                    ]
                                  },
                                  {
                                    boxStlz: a('f/3 fd/ccc'),
                                    oClds: [
                                      cr.c(TextC.N, {
                                        key: -10,
                                        abtType: 'hdrPageNameCmnz',
                                        textz: {
                                          pfx: '部屋予約システム',
                                        }
                                      })
                                    ]
                                  },
                                  {
                                    boxStlz: a('f/1 fd/rec mr/2'),
                                    oClds: [
                                      pz.cz?.bLgt != false ?
                                      cr.c(BtnC.N, {
                                        key: -10,
                                        abtType: 'hdrLgtCmnz',
                                        bfrIconCz: {},
                                        lblCz: {},
                                        pslPtyz: {
                                          onPress: () => {
                                            icm.lgt();
                                          }
                                        }
                                      })
                                      : null,
                                    ]
                                  }
                                ]
                              }
                            ]
                          })
                        ]
                      },
                      {
                        oClds: [

                          cr.c(BoxC.N, {
                            key: -20,
                            boxStlz: 
                              cr.chkDvc() == 'p' ?
                                a('bc/lt5 bw/0 bwb/1 dw/f fd/rcc fw mh/a pv/1')
                              : a('bc/lt5 bw/0 bwb/1 dw/f fd/ccc fw mh/a pv/1'),
                            oClds: [

                              cr.c(TextC.N, {
                                key: -10,
                                boxStlz: 
                                  cr.chkDvc() == 'p' ?
//                                    a('dw/40 f/n fd/rec pr/1 sc/t')
                                    a('f/n sc/t')
//                                  : a('dw/40 f/n fd/ccc sc/t'),
                                  : a('f/n fd/ccc sc/t'),
                                textz: {
                                  pfx: `${$date}`,
                                  stlz: a(`tb ts/xl`),
                                }
                              }),

                              cr.c(TextC.N, {
                                key: -20,
                                boxStlz: 
                                  cr.chkDvc() == 'p' ?
//                                    a('dw/80 f/n fd/rsc pl/1 sc/t')
                                    a('f/n pl/1 sc/t')
//                                  : a('dw/40 f/n fd/ccc sc/t'),
                                  : a('f/n fd/ccc sc/t'),
                                textz: {
                                  pfx: `${_gUserz.crt.i18rz?._pfx ?? ''} 様`,
                                  stlz: a(`tb ts/xl`),
                                }
                              }),

                              cr.c(TextC.N, {
                                key: -30,
                                boxStlz: 
                                  cr.chkDvc() == 'p' ?
//                                    a('dw/80 f/n fd/rsc pl/1 sc/t')
                                    a('f/n pl/1 sc/t')
//                                  : a('dw/40 f/n fd/ccc sc/t'),
                                  : a('f/n fd/ccc sc/t'),
                                textz: {
                                  pfx: `（${_gUserz.crt.i18rz?.i18rab100s ?? ''}）`,
                                  stlz: a(`tb ts/xl`),
                                }
                              })

                            ]
                          })

                        ]
                      },
                      {
                        oClds: [

                          pz.sPz.crt.dffz ?
                          cr.c(TextC.N, {
                            key: -10,
                            boxStlz: 
                              a(`sc/${pz.sPz.crt.dffz?.clr ?? 'lt'}3 dh/6 dw/f fd/ccc`),
                            textz: {
                              pfx: 
                                pz.sPz.crt.ctt == 'r' ?
                                  '直接予約'
                                : pz.sPz.crt.ctt == 'e' ?
                                  'エントリー'
                                : pz.sPz.crt.ctt == 's' ?
                                  '設定変更'
                                : '',
                              stlz: a('tb tc/lt9 ts/xl'),
                            }
                          })
                          : null,

                        ]
                      },
                      {
                        oClds: [

                          cr.c(TextC.N, {
                            key: -10,
                            boxStlz: a('dw/f fd/ccc pv/1'),
                            textz: {
                              pfx: pz.sPz.crt._31rz?._pfx ?? '',
                              stlz: a('tb ts/xl'),
                            }
                          }),

                        ]
                      },

                      {
                        boxStlz: a('dw/f f/1 ph/1 pt/1 pb/4'),
                        oClds: pz.oClds,
                      },
                    ]
                  }
                ]
              })
            ]
          }),

          cr.c(IccvFtr, {
            key: -20,
          })

        ]
      }
    })



  );
};
